import apis from '@/apis/requirement';
import { RequirementConfirm } from "@/types/requirement";
import { getRequirementConfirmItem } from "../util";
import useRequirementParams from "./useRequirementParams";
import { useState } from "react";

type EditRequirement = (type: "next" | "prev", desc: string, successCallback: () => void) => Promise<void>;
type UseEditRequirementProgress = (id: string, confirms: Array<RequirementConfirm>) => [EditRequirement, boolean]

const useEditRequirementProgress: UseEditRequirementProgress = (id, confirms) => {
  const { params } = useRequirementParams(true);
  const [loading, setLoading] = useState<boolean>(false)

  const onEdit: EditRequirement = async (type, desc, successCallback) => {
    if (id && params && params.confirmType) {
      setLoading(true)
      try {
        await apis.confirms(id, getRequirementConfirmItem(confirms, params.confirmType, type, desc))
        successCallback()
      } catch (e) {

      } finally {
        setLoading(false)
      }
    }
  };

  return [onEdit, loading]
};

export default useEditRequirementProgress;
